import { type NormalizedPost } from '../types';

export const TOGGLE_PIN_POST_REQUEST = 'post/TOGGLE_PIN_REQUEST' as const;
export const TOGGLE_PIN_POST_SUCCESS = 'post/TOGGLE_PIN_SUCCESS' as const;
export const TOGGLE_PIN_POST_FAILURE = 'post/TOGGLE_PIN_FAILURE' as const;

export type TogglePinPostRequestAction = {
  type: typeof TOGGLE_PIN_POST_REQUEST;
};

export type TogglePinPostSuccessAction = {
  type: typeof TOGGLE_PIN_POST_SUCCESS;
  payload: NormalizedPost;
};

export type TogglePinPostFailureAction = {
  type: typeof TOGGLE_PIN_POST_FAILURE;
};

export type TogglePinPostAction =
  | TogglePinPostRequestAction
  | TogglePinPostSuccessAction
  | TogglePinPostFailureAction;
